
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"100","height":"100","preserveAspectRatio":"xMidYMid"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M20 0h60v100H20z"}})])]),_c('path',{attrs:{"fill":"none","stroke":"var(--primary, #00af87)","stroke-width":"6","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","clip-path":"url(#a)","d":"M90 76.7V28.3c0-2.7-2.2-5-5-5h-3.4c-2.7 0-5 2.2-5 5v43.4c0 2.7-2.2 5-5 5h-3.4c-2.7 0-5-2.2-5-5V28.3c0-2.7-2.2-5-5-5H55c-2.7 0-5 2.2-5 5v43.4c0 2.7-2.2 5-5 5h-3.4c-2.7 0-5-2.2-5-5V28.3c0-2.7-2.2-5-5-5h-3.4c-2.7 0-5 2.2-5 5v43.4c0 2.7-2.2 5-5 5H15c-2.7 0-5-2.2-5-5V23.3"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"translate","repeatCount":"indefinite","dur":"1.4925373134328357s","values":"-20 0;7 0","keyTimes":"0;1"}}),_c('animate',{attrs:{"attributeName":"stroke-dasharray","repeatCount":"indefinite","dur":"1.4925373134328357s","values":"0 72 125 232;0 197 125 233","keyTimes":"0;1"}})])])
          )
        }
      }
    